import { css } from '@emotion/css';

export const questionCodeStyles = css`
  pre {
    background: var(--gray-100) !important;
    border-radius: 0.8rem;
    padding: 1.6rem;
    font-weight: normal;

    code {
      white-space: pre-wrap;
    }
  }
`;
